export const l10n = {
    ko : {
        filter : "필터",
        all : "전체",
        deleteSearch: "Delete",
        insertName : "캐릭터 이름을 입력하세요.",
        noRecentSearch : "최근검색어 내역이 없습니다.",
        deleteAllrecord : "전체 기록 삭제",
        searchResultLeng : "검색결과 {n} 건",
        masteryLevel : "홍문{n}성",
        recentViewChar : "최근 본 캐릭터",
        useCharSearch : "캐릭터 검색을 사용해보세요.",
        noSearchResult : "검색 결과가 없습니다.",
        noData : "다시 확인하시고, 검색해 주시기 바랍니다.",
        loading : "데이터 로딩 중입니다.",
        close : "닫기",
        takeCharPhoto : "캐릭터 사진 찍기",

        compare : "비교",
        whisper : "귓속말",
        inviteParty : "파티초대",
        applyFriend : "NC친구 신청",
        subscribe : "구독",

        weapon : "무기",
        ring : "반지",
        earring : "귀걸이",
        necklace : "목걸이",
        bracelet : "팔찌",
        belt : "허리띠",
        gloves : "장갑",
        soul : "령",
        soul2 : "혼",
        guard : "수호석",
        nova : "성",
        singongpae : "신공패",
        rune : "비공패",
        clothes : "의상",
        clothesDecoration : "의상장식",
        tire : "머리장식",
        faceDecoration : "얼굴장식",
        illusionDeco : "환영연출",

        idleState : "환영 대기 연출",
        vehicle : "탈것",
        namePlate : "명패",
        speechBubble : "말풍선",

        gemTab1 : "장착 보패",
        gemTab2 : "예비 보패",

        showMore : "자세히 보기",

        step : "단계",
        basic : "기본",
        equip : "장비",

        attackPower : "공격력",
        pcAttackPower : "대인 공격력",
        bossAttackPower : "항마 공격력",
        pierce : "관통",
        defendPierce : "방어 관통",
        parryPierce : "막기 관통",
        attackHit : "명중",
        attackHitRate : "명중 확률",
        attackConcentrate : "집중",
        attackPerfectParryDamageRate : "막기무공 관통",
        attackCounterDamageRate : "반격무공 관통",
        attackCritical : "치명",
        attackCriticalRate : "치명 확률",
        attackCriticalDamage : "치명 피해",
        attackCriticalDamageRate : "피해 증가",
        attackStiffDuration : "숙련",
        attackDamageModify : "추가 피해",
        hatePowerest : "위협",
        hatePowerRate : "위협율",
        abnormalAttackPower : "상태이상피해",
        attackAttribute : "공력",
        attackAttributeRate : "공력 피해율",
        guardGauge : "강체",
        maxHp : "생명력",
        defendPower : "방어력",
        defendPowerRate : "방어율",
        aoeDefendPower : "광역 방어력",
        aoeDefendDamageReduceRate : "광역 방어율",
        pcDefendPower : "대인 방어력",
        pcDefendPowerRate : "대인 방어율",
        bossDefendPower : "항마 방어력",
        bossDefendPowerRate : "항마 방어율",
        defendDodge : "회피",
        probability: "확률",
        counterDamageReduceRate : "반격무공 강화",
        defendParry : "막기",
        defendParryRate : "막기 확률",
        perfectParryDamageReduceRate : "막기무공 강화",
        defendCritical : "치명 방어",
        defendCriticalRate : "치명방어 확률",
        defendCriticalDamageRate : "피해 감소",
        defendStiffDurationLevel : "근성",
        hpRegen : "재생",
        stateOfPeace : "평화 상태",
        hpRegenCombat : "전투 상태",
        healPowerRate : "회복",
        healPower : "회복력",
        healPowerDiff : "추가 회복력",
        healPowerRate2 : "회복율",
        abnormalDefendPower : "상태이상방어력",
        abnormalDefendPowerRate : "상태이상방어율",
        soulShield1: '보패/감1',
        soulShield2: '보패/간2',
        soulShield3: '보패/진3',
        soulShield4: '보패/손4',
        soulShield5: '보패/리5',
        soulShield6: '보패/곤6',
        soulShield7: '보패/태7',
        soulShield8: '보패/건8',
        illusionWeapon: '환영무기',
        petAura: '수호석 원석',
        
    },
    en : {
        filter : "Filter",
        all : "All",
        deleteSearch: "Delete",
        insertName : "Try character search.",
        noRecentSearch : "No recent searches.",
        deleteAllrecord : "Clear records",
        searchResultLeng : "{n} search results",
        masteryLevel : "Hongmoon Level {n}",
        recentViewChar : "Recent Characters",
        useCharSearch : "Try searching for a Character.",
        noSearchResult : "No matches found.",
        noData : "Please check and search again.",
        loading : "Loading Data...",
        close : "Close",
        takeCharPhoto : "Take a Character Portrait",

        compare : "compare",
        whisper : "Whisper ",
        inviteParty : "Invite to Party ",
        applyFriend : "Send Friend Request",
        subscribe : "Subscribe",

        weapon : "Weapon",
        ring : "Ring",
        earring : "Earring",
        necklace : "Necklace",
        bracelet : "Bracelet",
        belt : "Belt",
        gloves : "Gloves",
        soul : "Soul",
        soul2 : "Heart",
        guard : "Pet",
        nova : "Talisman",
        singongpae : "Soul Badge",
        rune : "Mystic Badge",
        clothes : "Outfit",
        clothesDecoration : "Adornment",
        tire : "Head Adornment",
        faceDecoration : "Face Adornment",
        illusionDeco : "환영 연출",//------

        idleState : "환영 대기 연출",
        vehicle : "탈것",
        namePlate : "명패",
        speechBubble : "말풍선",

        gemTab1 : "Equipped<br>Soul Shield",
        gemTab2 : "Alternate<br>Soul Shield",

        showMore : "Preview",

        step : "Level",
        basic : "Base",
        equip : "Equipment",

        attackPower : "Attack Power",
        pcAttackPower : "PvP Attack Power",
        bossAttackPower : "Boss Attack Power",
        pierce : "Piercing",
        defendPierce : "Defense Piercing",
        parryPierce : "Block Piercing",
        attackHit : "Accuracy",
        attackHitRate : "Hit Rate",
        attackConcentrate : "Concentration",
        attackPerfectParryDamageRate : "Block Piercing",
        attackCounterDamageRate : "Counter Piecing",
        attackCritical : "Critical",
        attackCriticalRate : "Critical Rate",
        attackCriticalDamage : "Critical Damage",
        attackCriticalDamageRate : "Damage Bonus",
        attackStiffDuration : "Mastery",
        attackDamageModify : "Additional Damage",
        hatePowerest : "Threat",
        hatePowerRate : "Threat Bonus",
        abnormalAttackPower : "Debuff Damage",
        attackAttribute : "Mystic",
        attackAttributeRate : "Mystic Damage Rate",
        guardGauge : "Resilience",
        maxHp : "HP",
        defendPower : "Defense",
        defendPowerRate : "Defense Rate",//------
        aoeDefendPower : "AoE Defense",
        aoeDefendDamageReduceRate : "AoE Defense Rate",
        pcDefendPower : "PvP Defense",
        pcDefendPowerRate : "PvP Defense Rate",
        bossDefendPower : "Boss Defense",
        bossDefendPowerRate : "Boss Defense Rate",
        defendDodge : "Evasion",
        probability: "Rate",//------
        counterDamageReduceRate : "Enhanced Counter",
        defendParry : "Block",
        defendParryRate : "Block Rate",
        perfectParryDamageReduceRate : "Enhanced Block",
        defendCritical : "Critical Defense",
        defendCriticalRate : "Critical Defense Rate",
        defendCriticalDamageRate : "Damage Reduction",
        defendStiffDurationLevel : "Willpower",
        hpRegen : "Health Regen",
        stateOfPeace : "Out of Combat",
        hpRegenCombat : "In Combat",
        healPowerRate : "Recovery",
        healPower : "Recovery Rate",
        healPowerDiff : "Recovery Bonus",
        healPowerRate2 : "Recovery Chance",
        abnormalDefendPower : "Debuff Defense",
        abnormalDefendPowerRate : "Debuff Defense Bonus",
        soulShield1: "Soul Shield 1",
        soulShield2: "Soul Shield 2",
        soulShield3: "Soul Shield 3",
        soulShield4: "Soul Shield 4",
        soulShield5: "Soul Shield 5",
        soulShield6: "Soul Shield 6",
        soulShield7: "Soul Shield 7",
        soulShield8: "Soul Shield 8",
        illusionWeapon: "Illusion Weapon",
        petAura: "Pet Aura",
    },
    zh: {
        filter : "篩選",
        all : "全體",
        deleteSearch: "Delete",
        insertName : "請輸入角色名稱。",
        noRecentSearch : "沒有最近的搜尋關鍵字。",
        deleteAllrecord : "刪除全部記錄。",
        searchResultLeng : "搜尋結果{n}件",
        masteryLevel : "洪門{n}星",
        recentViewChar : "最近查看角色",
        useCharSearch : "請使用角色搜尋。",
        noSearchResult : "沒有搜尋結果。",

        noData : "請確認後再次進行搜尋。",
        loading : "數據加載中。",
        close : "關閉",
        takeCharPhoto : "拍攝角色照片",

        compare : "比較",
        whisper : "悄悄話",
        inviteParty : "隊伍邀請",
        applyFriend : "NC好友申請",
        subscribe : "訂閱",

        weapon : "武器",
        ring : "戒指",
        earring : "耳環",
        necklace : "項鍊",
        bracelet : "手鐲",
        belt : "腰帶",
        gloves : "護拳",
        soul : "魂",
        soul2 : "靈",
        guard : "守護石",
        nova : "星",
        singongpae : "神功牌",
        rune : "祕功牌",
        clothes : "服裝",
        clothesDecoration : "服飾",
        tire : "頭飾",
        faceDecoration : "臉飾",
        illusionDeco : "幻影特效",

        idleState : "",
        vehicle : "",
        namePlate : "",
        speechBubble : "",

        gemTab1 : "裝備八卦牌",
        gemTab2 : "預備八卦牌",

        showMore : "詳細查看",

        step : "階段",
        basic : "基本",
        equip : "裝備",

        attackPower : "攻擊力",
        pcAttackPower : "對人攻擊力",
        bossAttackPower : "降魔攻擊力",
        pierce : "貫穿",
        defendPierce : "防禦貫穿",
        parryPierce : "格擋貫穿",
        attackHit : "命中",
        attackHitRate : "命中率",
        attackConcentrate : "集中",
        attackPerfectParryDamageRate : "格擋招式貫穿",
        attackCounterDamageRate : "反擊招式貫穿",
        attackCritical : "暴擊",
        attackCriticalRate : "暴擊率",
        attackCriticalDamage : "暴擊傷害",
        attackCriticalDamageRate : "傷害提升",
        attackStiffDuration : "熟練",
        attackDamageModify : "額外傷害",
        hatePowerest : "威脅",
        hatePowerRate : "威脅率",
        abnormalAttackPower : "異常狀態傷害",
        attackAttribute : "功力",
        attackAttributeRate : "功力傷害率",
        guardGauge : "剛體",
        maxHp : "生命力",
        defendPower : "防禦力",
        defendPowerRate : "防御率",
        aoeDefendPower : "範圍防禦力",
        aoeDefendDamageReduceRate : "範圍防禦率",
        pcDefendPower : "對人防禦力",
        pcDefendPowerRate : "對人防禦率",
        bossDefendPower : "降魔防禦力",
        bossDefendPowerRate : "降魔防禦率",
        defendDodge : "閃避",

        probability: "率",

        counterDamageReduceRate : "反擊招式強化",
        defendParry : "格擋",
        defendParryRate : "格擋率",
        perfectParryDamageReduceRate : "格擋招式強化",
        defendCritical : "暴擊防禦",
        defendCriticalRate : "暴擊防禦率",
        defendCriticalDamageRate : "傷害減免",
        defendStiffDurationLevel : "韌性",
        hpRegen : "再生",
        stateOfPeace : "和平狀態",
        hpRegenCombat : "戰鬥狀態",
        healPowerRate : "恢復",
        healPower : "恢復力",

        healPowerDiff : "額外恢復力",
        healPowerRate2 : "恢復率",
        abnormalDefendPower : "異常狀態防禦力",
        abnormalDefendPowerRate : "異常狀態防禦率",
        soulShield1: "八卦牌 坎1",
        soulShield2: "八卦牌 艮2",
        soulShield3: "八卦牌 震3",
        soulShield4: "八卦牌 巽4",
        soulShield5: "八卦牌/離5",
        soulShield6: "八卦牌 坤6",
        soulShield7: "八卦牌 兑7",
        soulShield8: "八卦牌 乾8",
        illusionWeapon: "幻影武器",
        petAura: "守護石 原石",
    },
    cn : {
        filter : "过滤器",
        all : "全体",
        deleteSearch: "删除",
        insertName : "请输入角色名。",
        noRecentSearch : "无近期搜索内容。",
        deleteAllrecord : "删除全体记录",
        searchResultLeng : "搜索结果 {n} 个",
        masteryLevel : "洪门{n}星",
        recentViewChar : "最近查看过的角色",
        useCharSearch : "请使用角色查询。",
        noSearchResult : "无查询结果。",
        noData : "请在重新确认后查询。",
        loading : "数据载入中。",
        close : "关闭",
        takeCharPhoto : "拍摄角色照片",

        compare : "比较",
        whisper : "悄悄话",
        inviteParty : "组队邀请",
        applyFriend : "好友申请",
        subscribe : "订阅",

        weapon : "武器",
        ring : "戒指",
        earring : "耳环",
        necklace : "项链",
        bracelet : "手镯",
        belt : "腰带",
        gloves : "手套",
        soul : "灵",
        soul2 : "魂",
        guard : "守护石",
        nova : "星",
        singongpae : "神功牌",
        rune : "秘功牌",
        clothes : "服装",
        clothesDecoration : "服饰",
        tire : "头饰",
        faceDecoration : "脸饰",
        illusionDeco : "待机特效",

        idleState : "",
        vehicle : "",
        namePlate : "",
        speechBubble : "",

        gemTab1 : "装备八卦牌",
        gemTab2 : "备用八卦牌",

        showMore : "详细内容",

        step : "阶段",
        basic : "基本",
        equip : "装备",

        attackPower : "攻击力",
        pcAttackPower : "PVP攻击力",
        bossAttackPower : "降魔攻击力",
        pierce : "穿刺",
        defendPierce : "防御穿刺",
        parryPierce : "格挡穿刺",
        attackHit : "命中",
        attackHitRate : "命中率",
        attackConcentrate : "集中",
        attackPerfectParryDamageRate : "格挡武功穿刺率",
        attackCounterDamageRate : "反击武功穿刺率",
        attackCritical : "暴击",
        attackCriticalRate : "暴击率",
        attackCriticalDamage : "暴击伤害",
        attackCriticalDamageRate : "提升伤害率",
        attackStiffDuration : "熟练",
        attackDamageModify : "额外伤害",
        hatePowerest : "嘲讽",
        hatePowerRate : "仇恨率",
        abnormalAttackPower : "状态异常伤害",
        attackAttribute : "功力",
        attackAttributeRate : "功力伤害率",
        guardGauge : "刚体",
        maxHp : "生命",
        defendPower : "防御",
        defendPowerRate : "防御率",
        aoeDefendPower : "范围伤害防御",
        aoeDefendDamageReduceRate : "范围伤害减免率",
        pcDefendPower : "PVP防御力",
        pcDefendPowerRate : "PVP防御率",
        bossDefendPower : "降魔防御力",
        bossDefendPowerRate : "降魔防御率",
        defendDodge : "闪避",
        probability: "概率",
        counterDamageReduceRate : "反击武功强化",
        defendParry : "格挡",
        defendParryRate : "格挡率",
        perfectParryDamageReduceRate : "格挡武功强化",
        defendCritical : "暴击防御",
        defendCriticalRate : "暴击防御率",
        defendCriticalDamageRate : "伤害减免",
        defendStiffDurationLevel : "韧性",
        hpRegen : "恢复",
        stateOfPeace : "和平状态",
        hpRegenCombat : "战斗状态",
        healPowerRate : "治疗",
        healPower : "治疗",
        healPowerDiff : "额外治疗",
        healPowerRate2 : "治疗率",
        abnormalDefendPower : "状态异常防御力",
        abnormalDefendPowerRate : "状态异常防御率",
        soulShield1: "八卦牌 坎1",
        soulShield2: "八卦牌 艮2",
        soulShield3: "八卦牌 震3",
        soulShield4: "八卦牌 巽4",
        soulShield5: "八卦牌 离5",
        soulShield6: "八卦牌 坤6",
        soulShield7: "八卦牌 兑7",
        soulShield8: "八卦牌 乾8",
        illusionWeapon: "幻影武器",
        petAura: "幻影石",
    },
    de : {
        filter : "Filtern",
        all : "Alle",
        deleteSearch: "Delete",
        insertName : "Gebt einen Charakternamen ein.",
        noRecentSearch : "Keine aktuellen Suchen.",
        deleteAllrecord : "Verlauf löschen",
        searchResultLeng : "{n} Suchergebnisse",
        masteryLevel : "Hongmoon-Stufe {n}",
        recentViewChar : "Aktuelle Charaktere",
        useCharSearch : "Nach einem Charakter suchen.",
        noSearchResult : "Kein Ergebnis gefunden.",
        noData : "Bitte überprüft Eure Eingabe und sucht erneut.",
        loading : "Daten werden geladen …",
        close : "Schließen",
        takeCharPhoto : "Charakterporträt aufnehmen",

        compare : "vergleichen",
        whisper : "Flüstern",
        inviteParty : "In Gruppe einladen",
        applyFriend : "Freundschaftsanfrage senden",
        subscribe : "Abonnieren",

        weapon : "Waffe",
        ring : "Ring",
        earring : "Ohrring",
        necklace : "Halsschmuck",
        bracelet : "Armband",
        belt : "Gürtel",
        gloves : "Handschuhe",
        soul : "Seele",
        soul2 : "Geist",
        guard : "Gefährtenstein",
        nova : "Amulett",
        singongpae : "Seelenabzeichen",
        rune : "Geistesabzeichen",
        clothes : "Kleidung",
        clothesDecoration : "Verzierung",
        tire : "Kopfverzierung",
        faceDecoration : "Gesichtsverzierung",
        illusionDeco : "환영 연출",//------

        idleState : "환영 대기 연출",
        vehicle : "탈것",
        namePlate : "명패",
        speechBubble : "말풍선",

        gemTab1 : "Angelegtes Bagua",
        gemTab2 : "Reserve-Bagua",

        showMore : "Vorschau",

        step : "Stufe",
        basic : "Grundwert",
        equip : "Ausrüstung",

        defendPowerRate : "Schadensreduktion",//------
        probability: "Prozentsatz",//------
        
        attackPower : "Angriffskraft",
        pcAttackPower : "PvP-Angriffsk.",
        bossAttackPower : "Boss-Angriffsk.",
        pierce : "Durchdringung",
        defendPierce : "Verteidigungsdurchdr.",
        parryPierce : "Blockdurchdr.",
        attackHit : "Genauigkeit",
        attackHitRate : "Trefferrate",
        attackConcentrate : "Konzentration",
        attackPerfectParryDamageRate : "Durchdringung der Blockfertigkeit",
        attackCounterDamageRate : "Durchdringung der Konterfertigkeit",
        attackCritical : "Kritisch",
        attackCriticalRate : "Krit. Trefferrate",
        attackCriticalDamage : "Krit. Schaden",
        attackCriticalDamageRate : "Schadensbonus",
        attackStiffDuration : "Beherrschung",
        attackDamageModify : "Bonusschaden",
        hatePowerest : "Bedrohung",
        hatePowerRate : "Bedrohungsbonus",
        abnormalAttackPower : "Debuffschaden",
        attackAttribute : "Chi-Kraft",
        attackAttributeRate : "Chi-Schaden",
        guardGauge : "Widerstand",
        maxHp : "LP",
        defendPower : "Verteidigung",
        aoeDefendPower : "Flächeneffekt-Verteidigung",
        aoeDefendDamageReduceRate : "Flächeneffekt-Schadensred.",
        pcDefendPower : "PvP-Verteidigung",
        pcDefendPowerRate : "PvP-Schadensreduktion",
        bossDefendPower : "Boss-Verteid.",
        bossDefendPowerRate : "Boss-Schadensreduktion",
        defendDodge : "Ausweichen",
        counterDamageReduceRate : "Konterbonus",
        defendParry : "Blocken",
        defendParryRate : "Blockchance",
        perfectParryDamageReduceRate : "Blockbonus",
        defendCritical : "Krit. Verteidigung",
        defendCriticalRate : "Krit. Verteidigungsrate",
        defendCriticalDamageRate : "Schadensred.",
        defendStiffDurationLevel : "Willenskraft",
        hpRegen : "Lebensreg.",
        stateOfPeace : "Außerhalb des Kampfes",
        hpRegenCombat : "Im Kampf",
        healPowerRate : "Erholung",
        healPower : "Erholungsrate",
        healPowerDiff : "Erholungsbonus",
        healPowerRate2 : "Erholungschance",
        abnormalDefendPower : "Debuffvert.",
        abnormalDefendPowerRate : "Debuff-Schadensreduktion",
        soulShield1: "Bagua 1",
        soulShield2: "Bagua 2",
        soulShield3: "Bagua 2",
        soulShield4: "Bagua 2",
        soulShield5: "Bagua 2",
        soulShield6: "Bagua 2",
        soulShield7: "Bagua 2",
        soulShield8: "Bagua 2",
        illusionWeapon: "Illusionswaffe",
        petAura: "Illusionsstein",
    },
    fr : {
        deleteSearch: "Delete",
        filter : "Filtrer",
        all : "Tout",
        insertName : "Saisissez le nom d'un personnage.",
        noRecentSearch : "Aucune recherche récente.",
        deleteAllrecord : "Nettoyer les résultats",
        searchResultLeng : "{n} résultat(s) de recherche",
        masteryLevel : "Niveau de Hongmoon {n}",
        recentViewChar : "Personnages récents",
        useCharSearch : "Cherchez un personnage.",
        noSearchResult : "Auncun résultat trouvé.",
        noData : "Veuillez vérifier et réessayer.",
        loading : "Chargement des données…",
        close : "Fermer",
        takeCharPhoto : "Capturer un portrait de personnage",

        compare : "comparer",
        whisper : "Murmurer",
        inviteParty : "Inviter en groupe",
        applyFriend : "Envoyer une demande d'ami",
        subscribe : "S'abonner",

        weapon : "Arme",
        ring : "Anneau",
        earring : "Boucle d'oreille",
        necklace : "Collier",
        bracelet : "Bracelet",
        belt : "Ceinture",
        gloves : "Gants",
        soul : "Âme",
        soul2 : "Esprit",
        guard : "Pierre gardienne",
        nova : "Charme",
        singongpae : "Amulette divine",
        rune : "Amulette impétueuse",
        clothes : "Tenue",
        clothesDecoration : "Accessoire",
        tire : "Accessoire de tête",
        faceDecoration : "Accessoire de visage",
        illusionDeco : "환영 연출",//------

        idleState : "환영 대기 연출",
        vehicle : "탈것",
        namePlate : "명패",
        speechBubble : "말풍선",

        gemTab1 : "Bagua<br>équipé",
        gemTab2 : "Bagua<br>de réserve",

        showMore : "Aperçu",

        step : "Niveau",
        basic : "Base",
        equip : "Équipement",

        defendPowerRate : "Defense Rate",//------
        probability: "Rate",//------

        attackPower : "P.A.",
        pcAttackPower : "P.A. en JcJ",
        bossAttackPower : "P.A. magique",
        pierce : "Perforation",
        defendPierce : "Perfo. Déf.",
        parryPierce : "Perfo. Garde",
        attackHit : "Précision",
        attackHitRate : "Taux préc.",
        attackConcentrate : "Concentration",
        attackPerfectParryDamageRate : "Perfo. Garde",
        attackCounterDamageRate : "Perfo. Contre",
        attackCritical : "Coup critique",
        attackCriticalRate : "Taux C.C.",
        attackCriticalDamage : "Dégâts critiques",
        attackCriticalDamageRate : "Dégâts bonus",
        attackStiffDuration : "Maîtrise",
        attackDamageModify : "Dégâts suppl.",
        hatePowerest : "Inimité",
        hatePowerRate : "Bonus Inim.",
        abnormalAttackPower : "Dégâts altérations",
        attackAttribute : "Force de frappe",
        attackAttributeRate : "Taux F.F.",
        guardGauge : "Robustesse",
        maxHp : "P.V.",
        defendPower : "Défense",
        aoeDefendPower : "Déf. Zone",
        aoeDefendDamageReduceRate : "Réd. Dég. Zone",
        pcDefendPower : "Déf. en JcJ",
        pcDefendPowerRate : "Réd. Dég. JcJ",
        bossDefendPower : "Déf. Magique",
        bossDefendPowerRate : "Réd. Dég. Mag.",
        defendDodge : "Esquive",
        counterDamageReduceRate : "Bonus Contre",
        defendParry : "Garde",
        defendParryRate : "Taux Garde",
        perfectParryDamageReduceRate : "Bonus Garde",
        defendCritical : "Défense critique",
        defendCriticalRate : "Taux Déf. Crit.",
        defendCriticalDamageRate : "Réd. Dégâts",
        defendStiffDurationLevel : "Ténacité",
        hpRegen : "Régénération",
        stateOfPeace : "Hors combat",
        hpRegenCombat : "En combat",
        healPowerRate : "Récupération",
        healPower : "Taux récup.",
        healPowerDiff : "Bonus récup.",
        healPowerRate2 : "Chance récup.",
        abnormalDefendPower : "Rés. Altérations",
        abnormalDefendPowerRate : "Taux Rés. Alt.",
        soulShield1: "Bagua 1",
        soulShield2: "Bagua 2",
        soulShield3: "Bagua 2",
        soulShield4: "Bagua 2",
        soulShield5: "Bagua 2",
        soulShield6: "Bagua 2",
        soulShield7: "Bagua 2",
        soulShield8: "Bagua 2",
        illusionWeapon: "Arme d'illusion",
        petAura: "Pierre d'illusion",
    },
    pt : {
        deleteSearch: "Delete",

        filter : "Filtrar",
        all : "Tudo",
        insertName : "Insira o Nome do Personagem.",
        noRecentSearch : "Zero buscas recentes.",
        deleteAllrecord : "Limpar registros",
        searchResultLeng : "{n} resultado(s) de busca encontrado(s)",
        masteryLevel : "Nível Hongmoon: {n}",
        recentViewChar : "Personagens Recentes",
        useCharSearch : "Busque por um Personagem.",
        noSearchResult : "Nenhum resultado encontrado.",
        noData : "Por favor, verifique e busque novamente.",
        loading : "Carregando dados...",
        close : "Fechar",
        takeCharPhoto : "Tirar foto para Retrato do Personagem",

        compare : "comparar", //----

        whisper : "Sussurrar",
        inviteParty : "Convidar para o Grupo",
        applyFriend : "Enviar Pedido de amizade",
        subscribe : "Assinar",

        weapon : "Arma",
        ring : "Anel",
        earring : "Brinco",
        necklace : "Colar",
        bracelet : "Bracelete",
        belt : "Cinto",
        gloves : "Luvas",
        soul : "Alma",
        soul2 : "Coração",
        guard : "Mascote",
        nova : "Talismã",
        singongpae : "Distintivo da Alma",
        rune : "Distintivo Místico",
        clothes : "Traje",
        clothesDecoration : "Adereço",
        tire : "Adereço de Cabeça",
        faceDecoration : "Adereço de Rosto",
        illusionDeco : "환영 연출",//------

        idleState : "환영 대기 연출",
        vehicle : "탈것",
        namePlate : "명패",
        speechBubble : "말풍선",

        gemTab1 : "Escudo da Alma<br>Equipado",
        gemTab2 : "Alternar E.<br>da Alma",

        showMore : "Prévia",

        step : "Nível",
        basic : "Básico",
        equip : "Equipamento",

        defendPowerRate : "Defense Rate",//------
        probability: "Rate",//------

        attackPower : "Poder de Ataque",
        pcAttackPower : "Poder de Ataque JxJ",
        bossAttackPower : "Poder de Ataque a Chefes",
        pierce : "Perfuração",
        defendPierce : "Perfuração de Defesa",
        parryPierce : "Perfuração de Bloqueio",
        attackHit : "Precisão",
        attackHitRate : "Taxa de Acerto",
        attackConcentrate : "Concentração",
        attackPerfectParryDamageRate : "Perfuração de Bloqueio",
        attackCounterDamageRate : "Perfuração de Reação",
        attackCritical : "Crítico",
        attackCriticalRate : "Taxa de Crítico",
        attackCriticalDamage : "Dano Crítico",
        attackCriticalDamageRate : "Bônus de Dano",
        attackStiffDuration : "Maestria",
        attackDamageModify : "Dano Adicional",
        hatePowerest : "Ameaça",
        hatePowerRate : "Bônus de Ameaça",
        abnormalAttackPower : "Dano de Penalidade",
        attackAttribute : "Místico",
        attackAttributeRate : "Taxa de Dano Místico",
        guardGauge : "Resistência",
        maxHp : "PV",
        defendPower : "Defesa",
        aoeDefendPower : "Defesa AdE",
        aoeDefendDamageReduceRate : "Taxa de Defesa AdE",
        pcDefendPower : "Defesa JxJ",
        pcDefendPowerRate : "Taxa de Defesa JxJ",
        bossDefendPower : "Defesa contra Chefes",
        bossDefendPowerRate : "Taxa de Defesa contra Chefes",
        defendDodge : "Desvio",
        counterDamageReduceRate : "Reação Aprimorada",
        defendParry : "Bloquear",
        defendParryRate : "Taxa de Bloqueio",
        perfectParryDamageReduceRate : "Bloqueio Aprimorado",
        defendCritical : "Defesa de Crítico",
        defendCriticalRate : "Taxa de Defesa de Crítico",
        defendCriticalDamageRate : "Redução de Dano",
        defendStiffDurationLevel : "Força de Vontade",
        hpRegen : "Regeneração de Saúde",
        stateOfPeace : "Fora de Combate",
        hpRegenCombat : "Em Combate",
        healPowerRate : "Recuperação",
        healPower : "Taxa de Recuperação",
        healPowerDiff : "Bônus de Recuperação",
        healPowerRate2 : "Chance de Recuperação",
        abnormalDefendPower : "Defesa de Penalidade",
        abnormalDefendPowerRate : "Bônus de Defesa de Penalidade",
        soulShield1: "E. da Alma 1",
        soulShield2: "E. da Alma 2",
        soulShield3: "E. da Alma 3",
        soulShield4: "E. da Alma 4",
        soulShield5: "E. da Alma 5",
        soulShield6: "E. da Alma 6",
        soulShield7: "E. da Alma 7",
        soulShield8: "E. da Alma 8",
        illusionWeapon: "Arma de Ilusão",
        petAura: "Aura de Mascote",
    },
};

/*
 ko : 한국
 en : 영어
 zh : 대만
 cn : 중국
 de : 독일
 fr : 프랑스
 pt : 포르투갈
 */